export const pt = {
  header: {
    title: "Vá para o mundo. US$2 por Short. Em qualquer idioma!",
    subtitle: "🔥Pague apenas pelos resultados – de $0.089 a $0.009 por segundo🔥"
  },
  steps: { uploadVideo: "Enviar Vídeo", selectLanguages: "Selecionar Idiomas", conversionResult: "Conversão e Resultado" },
  upload: {
    dragAndDrop: "Arraste e solte seu arquivo de vídeo aqui", orClickToSelect: "ou clique para selecionar",
    supportedFormats: "Formatos suportados: MP4, AVI, MOV, MKV, WebM", maxFileSize: "• Tamanho máximo do arquivo: 200 MB",
    maxDuration: "• Duração máxima: 30 seg", processingTime: "• Processamento levará de 2 a 15 minutos dependendo da resolução do vídeo",
    chooseFile: "Escolher Arquivo", selectedFile: "Arquivo selecionado:", size: "Tamanho:",
    fileTypeError: "Por favor selecione um arquivo de vídeo", fileSizeError: "O tamanho do arquivo ({size} MB) excede o limite máximo de 200 MB",
    durationError: "A duração do vídeo ({duration} seg) excede o limite máximo de 30 seg",
    fileReadError: "Não é possível ler o arquivo de vídeo. Tente um arquivo diferente."
  },
  languages: { sourceAudioLanguage: "Idioma de áudio origem", targetAudioLanguage: "Idioma de áudio destino", selectLanguage: "Selecionar idioma..." },
  languageOptions: { ru: "Russo", en: "Inglês", es: "Espanhol", fr: "Francês", de: "Alemão", it: "Italiano", pt: "Português", pl: "Polonês", zh: "Chinês", ja: "Japonês", ko: "Coreano", bg: "Búlgaro", hr: "Croata", cs: "Tcheco", da: "Dinamarquês", nl: "Holandês", et: "Estoniano", fi: "Finlandês", el: "Grego", hu: "Húngaro", ga: "Irlandês", lv: "Letão", lt: "Lituano", mt: "Maltês", ro: "Romeno", sk: "Eslovaco", sl: "Esloveno", sv: "Sueco" },
  conversion: { replaceAudio: "Clonar minha voz", uploadVideoAndSelectLanguages: "Envie um vídeo e selecione os idiomas para continuar", fixValidationError: "Corrija o erro de validação do arquivo acima", createSubtitles: "Criar Legendas", uploadVideoForSubtitles: "Envie um vídeo para criar legendas", selectTranslationLanguage: "Selecione o idioma de tradução" },
  demo: { seeVeviInAction: "Ver VEVI em Ação", watchHowItWorks: "Veja como nossa tecnologia de substituição de voz IA funciona", beforeEnglish: "Antes (Inglês)", originalPresentation: "Apresentação corporativa original", afterSpanish: "Depois (Espanhol,Francês,Chinês,Italiano)", aiTranslatedVoice: "Traduzido por IA com voz natural", demoTitle: "Demo - VEVI em Ação" },
  reviews: { title: "O Que Nossos Clientes Dizem", subtitle: "Confiado por profissionais de marketing em todo o mundo", customerReviews: [
    { name: "Sarah Johnson", position: "Gerente de Marketing Digital", company: "TechFlow Solutions", text: "VEVI transformou nossas campanhas de marketing internacionais!" },
    { name: "Michael Chen", position: "Diretor de Marketing de Conteúdo", company: "GlobalReach Media", text: "Como alguém que gerencia conteúdo de vídeo para várias regiões, VEVI é revolucionário." },
    { name: "Emma Rodriguez", position: "Especialista em Marketing de Marca", company: "InnovateCorp", text: "Economizamos milhares em custos de dublagem expandindo para novos mercados." },
    { name: "David Thompson", position: "Gerente de Campanhas de Marketing", company: "NextGen Brands", text: "A velocidade e qualidade do VEVI são incomparáveis." },
    { name: "Lisa Park", position: "Líder de Marketing de Mídias Sociais", company: "CreativeEdge Agency", text: "VEVI tornou possível para nossa pequena agência oferecer serviços de vídeo multilíngues." },
    { name: "James Wilson", position: "Diretor de Marketing de Performance", company: "ScaleUp Ventures", text: "ROI é tudo em marketing de performance, e VEVI entrega." }
  ]},
  payment: { title: "Pagamento de Conversão", processingCost: "Custo de Processamento", duration: "Duração:", baseCost: "Custo base", discount: "Desconto ({promoCode}):", discountAmount: "Valor do desconto:", total: "Total:", emailToReceiveResult: "Email para receber o resultado", emailPlaceholder: "seu-email@exemplo.com", promoCode: "🎟️ Código Promocional (opcional)", promoCodePlaceholder: "Digite código promocional", check: "Verificar", checking: "Verificando...", addSubtitles: "Adicionar legendas ao vídeo", addSubtitlesDescription: "Gerar e incorporar legendas no idioma de destino", highQualityTranslation: "• Tradução IA de alta qualidade", originalVideoPreserved: "• Vídeo original preservado", fastProcessing: "• Processamento rápido (tipicamente 5-10 minutos)", resultWillBeSent: "• Resultado será enviado para o email especificado", cancel: "Cancelar", continue: "Continuar", enterEmail: "Digite seu email", enterValidEmail: "Digite um endereço de email válido", enterPromoCode: "Digite um código promocional", invalidPromoCode: "Código promocional inválido", validPromoCode: "Código promocional válido! Desconto de {discount}% aplicado" },
  progress: { title: "Processando Vídeo", uploadingAndExtracting: "🎬 Enviando e extraindo áudio", transcribingAndTranslating: "🗣️ Transcrevendo fala e traduzindo", synthesizingAudio: "🎵 Sintetizando nova faixa de áudio", step: "Passo:", error: "Erro" },
  result: { title: "Concluído! Seu vídeo foi processado", conversionCompleted: "Conversão concluída com sucesso!", processedVideoDescription: "🎬 Seu vídeo processado com clonagem de voz", payAndDownload: "Pagar e Baixar", videoNotAvailable: "Vídeo não disponível", useDownloadButton: "Use o botão de download abaixo", downloadError: "Erro de Download" },
  emailSent: { title: "Vídeo Enviado! 🎉", videoOnWay: "O vídeo já está a caminho do seu email 🙏❤️", checkInbox: "Verifique sua caixa de entrada e pasta de spam. O vídeo processado chegará em breve!", whatsNext: "O que vem a seguir?", checkEmail: "• Verifique seu email ({email})", checkSpam: "• Procure na pasta de spam se não encontrar", downloadAndEnjoy: "• Baixe e aproveite seu vídeo dublado!", close: "Fechar", processAnotherVideo: "Processar Outro Vídeo" },
  processingSteps: { uploading: "Enviando vídeo...", extracting: "Extraindo áudio...", transcribing: "Transcrevendo fala...", translating: "Traduzindo conteúdo...", synthesizing: "Sintetizando nova voz...", rendering: "Renderizando vídeo final...", complete: "Processamento concluído!" },
  common: { minutes: "minutos", seconds: "segundos", loading: "Carregando...", error: "Erro", success: "Sucesso" },
  socialMedia: {
    title: "Mantenha-se Conectado",
    description: "Obtenha as últimas atualizações sobre a tecnologia de voz com IA"
  },

  // Services (for Footer)
  services: {
    dubbing: "Dublagem",
    voiceClone: "Dublagem com clonagem de voz",
    newVoice: "Dublagem com nova voz",
    multilingual: "Dublagem multilíngue",
    multiSpeaker: "Dublagem multi-locutor",
    subtitles: "Legendas",
    subtitlesOnly: "Apenas legendas",
    multilingualSubtitles: "Legendas multilíngues",
    subtitlesDescription: "Gere automaticamente legendas precisas para qualquer plataforma.",
    subtitlesPrice: "Custo de processamento: $0.01/seg",
    addSubtitles: "Adicionar legendas",
    needsTranslation: "Precisa de tradução?",
    translationLanguage: "Idioma de tradução"
  },

  // Footer
  footer: {
    legal: "Legal",
    privacyPolicy: "Política de privacidade",
    termsOfUse: "Termos de uso"
  },

  // Navigation
  nav: {
    blog: "Blog"
  },

  // Blog (using English content as fallback)
  blog: {
    title: "Blog VEVI Monster",
    subtitle: "História e mitologia do universo VEVI",
    readMore: "Ler mais",
    backToBlog: "Voltar ao blog",
    articleNotFound: "Artigo não encontrado",
    characteristics: "Características",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi é um ser nascido dos vórtices de plasma de Zera-13b. Ele não é carne nem metal—seu corpo consiste em partículas vibrantes mantidas juntas por um campo eletromagnético.",
        metadata: {
          "Galáxia": "MoM-z14",
          "Idade": "13,4 bilhões de anos",
          "Tipo": "Planeta rochoso com atmosfera densa de metano e neônio",
          "Estrela": "Protostrela vermelha Zera-13",
          "Órbita": "Segundo planeta do sistema",
        },
        content: [
          "🌑 Descrição",
          "Zera-13b é um mundo antigo e quase esquecido, nascido em uma era quando o Universo estava apenas aprendendo a brilhar.",
          "Seu céu brilha com chamas verdes fracas, e a atmosfera densa treme com tempestades de neônio. A superfície é uma paisagem preto-cinza coberta de crateras vítreas onde os ventos de metano deixam rastros de fogo no ar.",
          "Sob a superfície estão cavernas de gás congelado, onde, segundo as lendas, nasceram as primeiras formas de energia capazes de pensar.",
          "👾 Vevi (Vevi Monster)",
          "Vevi é um ser nascido dos vórtices de plasma de Zera-13b.",
          "Ele não é carne nem metal—seu corpo consiste em partículas vibrantes mantidas juntas por um campo eletromagnético.",
          "Seus olhos brilham com a luz refletida da estrela Zera-13, e sua voz soa como o sussurro do vento de neônio.",
          "Vevi deixou seu mundo quando a protostrela começou a desaparecer. Ele viajou através de vazios intergalácticos, guiado pelo instinto de buscar nova energia.",
          "Agora ele vagueia pelos mundos, carregando consigo uma partícula da luz primordial de Zera-13b.",
          "O brilho veio do planeta",
          "Ele não tem pernas—porque o planeta tem gravidade enorme e ele simplesmente levita",
          "Ele se comunica (ou melhor, emite sons) semelhantes às ondas acústicas de golfinhos, baleias e orcas.",
          "Sua língua é chamada UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub é um ser do Universo primitivo, nascido em Sub Zone, uma região rara do espaço com alta densidade de matéria.",
        metadata: {
          "Nome do objeto": "Sub Zone (SUB-Z)",
          "Tipo de objeto": "Protocluster / região de formação de galáxias",
          "Época": "~200–300 milhões de anos após o Big Bang",
          "Desvio para o vermelho": "z ≈ 14–15",
          "Ascensão reta (RA)": "02h 17m 43s",
          "Declinação (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Dados Baddy Sub",
          "Corpo longo, fino e oblongo com dois membros inferiores na parte inferior e três olhos em formas estendidas no topo",
          "Ele não tem boca.",
          "Há também dois membros superiores finos que podem ser interpretados como braços.",
          "Dois dedos em cada membro.",
          "Todo o corpo se assemelha a um galho de árvore",
          "A pele tem uma estrutura fosca suave",
          "A cor é verde-acastanhada (pigmentação)",
          "Pode mudar de cor do ambiente como um camaleão.",
          "Descrição do planeta onde Baddy Sub nasceu:",
          "Sub Zone é uma região rara do Universo primitivo com alta densidade de matéria, onde as primeiras estruturas galácticas começaram a se formar. As observações indicam interações intensas de gás primordial, radiação e ondas gravitacionais. A região registrou padrões de sinal instáveis e atividade ressonante anômala, não característica de regiões protogalácticas típicas.",
          "Significância científica:",
          "Sub Zone é considerado um objeto-chave para estudar os estágios iniciais da montagem de galáxias, propagação de sinais no Universo jovem e a transição de campos de radiação caóticos para sistemas cósmicos estruturados.",
          "Status:",
          "Classificado como região de formação não resolvida. Mais pesquisas são necessárias.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Perguntas Frequentes",
    subtitle: "Tudo o que você precisa saber sobre VEVI",
    questions: [
      {
        question: "Vocês trabalham apenas com voz?",
        answer: "Sim — substituímos sua voz para que soe em outro idioma mantendo-a natural e autêntica."
      },
      {
        question: "Pago antes ou depois?",
        answer: "Depois. Você ouve o resultado primeiro, depois paga."
      },
      {
        question: "Reembolsos?",
        answer: "Não necessários — você paga apenas quando estiver satisfeito com o resultado."
      },
      {
        question: "Vídeo com mais de 15 minutos?",
        answer: "Sem problema. Pergunte ao nosso assistente de IA no chat online para instruções."
      },
      {
        question: "Posso escolher outra voz?",
        answer: "Não — clonamos apenas sua própria voz."
      },
      {
        question: "Pagamento mínimo?",
        answer: "A partir de $0.50."
      },
      {
        question: "Como obtenho meu vídeo?",
        answer: "Download instantâneo no seu navegador + cópia para seu email após o pagamento."
      },
      {
        question: "Descontos para pedidos grandes?",
        answer: "Sim — entre em contato com nosso assistente de IA no chat online."
      },
      {
        question: "Não encontrou sua resposta?",
        answer: "Pergunte ao nosso assistente de IA no chat online — estamos aqui para ajudar."
      },
      {
        question: "Formato não suportado?",
        answer: "Use um conversor ou obtenha ajuda rápida do nosso assistente de IA no chat online."
      },
      {
        question: "Meu vídeo inclui termos específicos que devem ser pronunciados corretamente. Posso controlar isso?",
        answer: "Sim — basta enviar uma mensagem ao nosso assistente de IA no chat online, e enviaremos instruções sobre como marcar ou preservar certos termos (por exemplo, deixá-los em inglês)."
      },
      {
        question: "Não recebi meu email. O que devo fazer?",
        answer: "O tempo de processamento pode variar devido ao volume da fila. Não se preocupe — seu arquivo está seguro. Você receberá uma notificação ou um link de download direto assim que estiver pronto."
      }
    ]
  }
};
